var map = {
	"./Block.vue": 1074,
	"./Linebreak.vue": 1087,
	"./Link.vue": 1088,
	"./List.vue": 1089,
	"./Listitem.vue": 1090,
	"./Paragraph.vue": 1091,
	"./Text.vue": 1092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1016;